// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "ap-northeast-1:b7a803b6-c4d7-4390-b872-436d6e4b0add",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_r45hv9UKl",
    "aws_user_pools_web_client_id": "4qageg94bkm67e0tmiosajnmnu",
    "oauth": {},
    "aws_content_delivery_bucket": "adt-consumer-prod",
    "aws_content_delivery_bucket_region": "ap-northeast-1",
    "aws_content_delivery_url": "https://d2g0aezjuvhe3w.cloudfront.net"
};


export default awsmobile;
